import { Controller } from "stimulus"

import Rails from "@rails/ujs";
export default class extends Controller {
  static targets = ["form"];

  type(event) {
    if (event.keyCode === 13 && event.target.nodeName === 'INPUT') {
      var form = event.target.form;
      var index = Array.prototype.indexOf.call(form, event.target);
      var nextElement = form.elements[index + 1];
      
      nextElement.focus();
      event.preventDefault();
    }
  }

  submit(event) {
    var element = event.currentTarget;
    var input_id = element.id;
    var matchId =  this.formTarget.dataset.matchId;

    if (element.id.includes('home')) {
      var away_input_id = input_id.replace("home", "away");
      var second_field = document.getElementById(away_input_id);
    }
    else {
      var home_input_id = input_id.replace("away", "home");
      var second_field = document.getElementById(home_input_id);
    }

    // Prevent the form from being submitted without being completely filled out
    if (element.value != '' && second_field.value != '') {
      var label = document.getElementById(`btn-${matchId}-save`);
      label.innerHTML = 'Salvando...';

      const url  = this.formTarget.action;
      const data = new FormData(this.formTarget);

      Rails.ajax({
        type: "POST",
        url: url,
        data: data
      });
      
    }
  }
}